import React from 'react';
import type { TextFieldProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface BirthDatePickerProps {
  label: string;
  /** Date stored as `YYYY-MM-DD` (empty string when unset). */
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  margin?: TextFieldProps['margin'];
  size?: TextFieldProps['size'];
}

const BirthDatePicker: React.FC<BirthDatePickerProps> = ({
  label,
  value,
  onChange,
  disabled,
  required,
  error,
  helperText,
  margin,
  size,
}) => {
  const parsed = value ? dayjs(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={parsed && parsed.isValid() ? parsed : null}
        onChange={(next) =>
          onChange(next && next.isValid() ? next.format('YYYY-MM-DD') : '')
        }
        disabled={disabled}
        format="DD/MM/YYYY"
        views={['year', 'month', 'day']}
        openTo="year"
        yearsOrder="desc"
        maxDate={dayjs()}
        minDate={dayjs().subtract(100, 'year')}
        slotProps={{
          textField: {
            fullWidth: true,
            required,
            error,
            helperText,
            margin,
            size,
            placeholder: 'zz/ll/aaaa',
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default BirthDatePicker;
